import React, { useEffect, useState } from 'react'

// styles
import {
    FiltersMain,

    FilterHeader,
    FilterBody
} from "../../../styles/ProductList";

// icons
import { BiPlus, BiMinus, BiSearch } from "react-icons/bi";

export default function FiltersView(props) {
    // props
    const {
        filtersList,

        onFilterChangeTriggered
    } = props

    // states
    const [currentFilterOpened, setCurrentFilterOpened] = useState(["price", "search by phrase"])
    const [currentFilterViewExpanded, setCurrentFilterViewExpanded] = useState([])

    // filter change
    const handleFilterChange = (ev, filterId) => {
        ev.preventDefault()

        console.log("filterId ", filterId.toString());

        const isIdExist = currentFilterOpened.find(cItem => cItem === filterId.toString())

        if (isIdExist) { // if id exists in the filter then remove it
            const updatedList = currentFilterOpened.filter(item => item !== filterId.toString())

            setCurrentFilterOpened(updatedList) // setting filter ids
        } else { // if id does not exists then add it
            setCurrentFilterOpened([...currentFilterOpened, filterId.toString()])  // setting filter ids
        }
    }

    // filter view expande
    const handleFiltersExpand = (ev, filterId) => {
        ev.preventDefault()

        if (filterId) {
            const isIdExist = currentFilterViewExpanded.find(item => item === filterId)

            if (isIdExist) { // if id exists in the filter then remove it
                const updatedList = currentFilterViewExpanded.filter(item => item !== filterId)

                setCurrentFilterViewExpanded(updatedList) // setting filter ids
            } else { // if id does not exists then add it
                setCurrentFilterViewExpanded([...currentFilterViewExpanded, filterId])  // setting filter ids
            }
        }
    }

    return (
        <FiltersMain className="col">
            <div className="inner">
                {
                    /* filter item */
                    filtersList?.length ? filtersList.map((item, index) => {
                        let filtersOptions = item?.values?.split(",")

                        return (
                            <React.Fragment key={`${item.name}_${index}`}>
                                {
                                    (item.name !== "price" && item.name !== "search by phrase") ? (  // IF THE FILTER IS NOR SEARCH NEITHER PRICE
                                        // filter item 
                                        <div className={`filter-item filter-material ${currentFilterOpened.find(cItem => cItem === item.name) ? "filter-visible" : "filter-hidden"}`}>
                                            {/* filter header */}
                                            <FilterHeader className={`${currentFilterOpened.find(cItem => cItem === item.name) ? "active" : "inactive"}`}>
                                                <div className="inner d-flex align-items-center cursor-pointer" onClick={ev => handleFilterChange(ev, item.name)}>
                                                    {/* text */}
                                                    <span className="text-uppercase media-body pe-2 st-fw-700">{item.name}</span>

                                                    {/* icon */}
                                                    <div className="icon st-line-height-0">
                                                        {
                                                            currentFilterOpened.find(cItem => cItem === item.name) ? (
                                                                <BiMinus />
                                                            ) : (
                                                                <BiPlus />
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </FilterHeader>

                                            {
                                                // filter body
                                                currentFilterOpened.find(cItem => cItem === item.name) ? (
                                                    <FilterBody className={`${currentFilterOpened.find(cItem => cItem === item.name) ? "active" : "inactive"}`}>
                                                        <div className="inner">
                                                            {
                                                                /* filter item */
                                                                filtersOptions?.length ? filtersOptions.map((filterItem, filterIndex) => (
                                                                    <div key={filterItem + "_" + filterIndex} className="filter-item mb-2">
                                                                        <label className="d-flex st-fw-600 cursor-pointer">
                                                                            <input type="checkbox" className="" />
                                                                            <span className="ps-2 media-body position-relative">
                                                                                {filterItem}
                                                                                {/* <span className="ms-1">(213)</span> */}
                                                                            </span>
                                                                        </label>
                                                                    </div>
                                                                )) : (
                                                                    <div>
                                                                        <p>No option available</p>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                    </FilterBody>
                                                ) : null
                                            }
                                        </div>
                                    ) : (
                                        <React.Fragment>
                                            { // PRICE FILTER
                                                (item.name === "price") ? ( // IF FILTER TYPE IS PRICE
                                                    <div className={`filter-item filter-material ${currentFilterOpened.find(cItem => cItem === item.name) ? "filter-visible" : "filter-hidden"}`}>
                                                        {/* filter header */}
                                                        <FilterHeader className={`${currentFilterOpened.find(cItem => cItem === item.name) ? "active" : "inactive"}`}>
                                                            <div className="inner d-flex align-items-center cursor-pointer" onClick={ev => handleFilterChange(ev, item.name)}>
                                                                {/* text */}
                                                                <span className="text-uppercase media-body pe-2 st-fw-700">{item.name}</span>

                                                                {/* icon */}
                                                                <div className="icon st-line-height-0">
                                                                    {
                                                                        currentFilterOpened.find(cItem => cItem === item.name) ? (
                                                                            <BiMinus />
                                                                        ) : (
                                                                            <BiPlus />
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                        </FilterHeader>

                                                        {
                                                            // filter body
                                                            currentFilterOpened.find(cItem => cItem === item.name) ? (
                                                                <FilterBody className={`${currentFilterOpened.find(cItem => cItem === item.name) ? "active" : "inactive"}`}>
                                                                    <div className="inner">
                                                                        <div className="price-filter-sec">
                                                                            {/* top */}
                                                                            <div className="top-sec d-flex align-items-center">
                                                                                <input type="text" className="form-control" placeholder="From" />
                                                                                <span className="mx-2">-</span>
                                                                                <input type="text" className="form-control" placeholder="To" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </FilterBody>
                                                            ) : null
                                                        }
                                                    </div>
                                                ) : null
                                            }

                                            {  // SEARCH FILTER
                                                (item.name === "search by phrase") ? ( // IF FILTER TYPE IS SEARCH
                                                    <div className={`filter-item filter-material ${currentFilterOpened.find(cItem => cItem === item.name) ? "filter-visible" : "filter-hidden"}`}>
                                                        {/* filter header */}
                                                        <FilterHeader className={`${currentFilterOpened.find(cItem => cItem === item.name) ? "active" : "inactive"}`}>
                                                            <div className="inner d-flex align-items-center cursor-pointer" onClick={ev => handleFilterChange(ev, item.name)}>
                                                                {/* text */}
                                                                <span className="text-uppercase media-body pe-2 st-fw-700">{item.name}</span>

                                                                {/* icon */}
                                                                <div className="icon st-line-height-0">
                                                                    {
                                                                        currentFilterOpened.find(cItem => cItem === item.name) ? (
                                                                            <BiMinus />
                                                                        ) : (
                                                                            <BiPlus />
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                        </FilterHeader>

                                                        {
                                                            // filter body
                                                            currentFilterOpened.find(cItem => cItem === item.name) ? (
                                                                <FilterBody className={`${currentFilterOpened.find(cItem => cItem === item.name) ? "active" : "inactive"}`}>
                                                                    <div className="inner">
                                                                        {/* search input */}
                                                                        <div className="search-form position-relative">
                                                                            <input type="text" className="form-control" placeholder="Keyword or phrase" />
                                                                            <div className="icon position-absolute">
                                                                                <BiSearch />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </FilterBody>
                                                            ) : null
                                                        }
                                                    </div>
                                                ) : null
                                            }
                                        </React.Fragment>
                                    )
                                }
                            </React.Fragment>
                        )
                    }) : null
                }


            </div>
        </FiltersMain>
    )
}
